module.exports = __webpack_public_path__ + "img/setting.9371ab74.svg";